import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/employee-status";

export const searchByPageEmployeeStatus = (searchObject) => axios.post(API_PATH + "/paging", searchObject);

export const getEmployeeStatusById = (serviceVatId) => axios.get(API_PATH + "/get-by-id/" + serviceVatId);

export const saveOrUpdateEmployeeStatus = serviceVat => axios.post(API_PATH + "/save-or-update", serviceVat);

export const deleteEmployeeStatus = serviceVatId => axios.delete(API_PATH + '/mark-delete/' + serviceVatId);

export const saveEmployeeStatusSyncEmployeeStatusHRM = (searchObject) => axios.post(API_PATH + "/sync-employee-status-from-HRM", searchObject);